import React, { useEffect, useState } from 'react';
import { View, StyleSheet, TouchableOpacity, Text, TextInput } from 'react-native';

import { Color, CommonProperties } from '../../styles';

export const Counter = (props) => {
  const { setNumber, number, disabled, minValue } = props;
  const maxValue = props.maxValue !== undefined ? props.maxValue : 20;
  const backgroundColor = disabled ? Color.disabled : Color.primary;
  const opacity = '80';
  const [minOpacity, setMinOpacity] = useState('');
  const [maxOpacity, setMaxOpacity] = useState('');

  const increaseNumber = () => {
    setNumber(number >= maxValue ? maxValue : number + 1);
  };

  const decreaseNumber = () => {
    setNumber(number <= minValue ? minValue : number - 1);
  };

  const onChangeNumber = (text) => {
    if (text === '') {
      setNumber(text);
      return;
    }
    if (/^\d+$/.test(text)) {
      const value = parseInt(text);
      if (value >= minValue && value <= maxValue) {
        setNumber(value);
      }
    }
  };

  //Here we set the opacity if number reaches max or min value
  useEffect(() => {
    if (disabled) {
      return;
    }
    const minOpacity = number === minValue ? opacity : '';
    setMinOpacity(minOpacity);
    const maxOpacity = number === maxValue ? opacity : '';
    setMaxOpacity(maxOpacity);
  }, [number, disabled, maxValue, minValue]);

  const onBlur = () => {
    if (number === '') {
      setNumber(minValue);
    }
  };

  return (
    <View style={styles.row}>
      <TouchableOpacity
        disabled={disabled}
        style={[styles.appButtonContainer, { backgroundColor: backgroundColor + minOpacity }]}
        onPress={decreaseNumber}
      >
        <Text style={styles.appButtonText}>-</Text>
      </TouchableOpacity>
      <TextInput
        editable={!disabled}
        style={styles.numericInput}
        keyboardType="numeric"
        textAlign="center"
        onChangeText={onChangeNumber}
        onBlur={onBlur}
        value={number.toString()}
        maxLength={2}
        selectTextOnFocus={true}
      />
      <TouchableOpacity
        disabled={disabled}
        style={[styles.appButtonContainer, { backgroundColor: backgroundColor + maxOpacity }]}
        onPress={increaseNumber}
      >
        <Text style={styles.appButtonText}>+</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  appButtonContainer: {
    ...CommonProperties.borderRadius,
    ...CommonProperties.px3,
    elevation: 8,
    width: 35,
    paddingBottom: 4,
  },
  appButtonText: {
    fontWeight: 'bold',
    fontSize: 20,
    color: Color.accent,
    alignSelf: 'center',
    textAlign: 'center',
  },
  numericInput: {
    ...CommonProperties.px3,
    width: 37,
    paddingBottom: 4,
    borderColor: Color.primary,
    fontSize: 16,
    alignContent: 'center',
    textAlign: 'center',
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});
